import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e137190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-queue" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Weet u zeker dat u dit bestand wilt verwijderen?", -1))

import { withDefaults } from 'vue'
import { FileImageOutlined } from '@ant-design/icons-vue'

export interface Props {
  mediaItems: { name:string, url:string }[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadQueue',
  props: {
    mediaItems: { default: () => [] }
  },
  emits: ['fileDeleted'],
  setup(__props: any, { emit }) {

const props = __props as { mediaItems: { name:string, url:string }[] }




function deleteMediaItem (index:number) : void {
  emit('fileDeleted', index)
}

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_list, {
      "item-layout": "horizontal",
      "data-source": __props.mediaItems,
      size: "small"
    }, {
      renderItem: _withCtx(({ item, index }) => [
        _createVNode(_component_a_list_item, null, {
          actions: _withCtx(() => [
            _createVNode(_component_a_popconfirm, {
              placement: "topRight",
              "ok-text": "Ja",
              "cancel-text": "Nee",
              onConfirm: ($event: any) => (deleteMediaItem(index))
            }, {
              title: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_button, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Verwijderen ")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_list_item_meta, null, {
              avatar: _withCtx(() => [
                _createVNode(_component_a_avatar, {
                  shape: "square",
                  style: { backgroundColor: '#f38929' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FileImageOutlined))
                  ]),
                  _: 1
                })
              ]),
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data-source"])
  ]))
}
}

})